// extracted by mini-css-extract-plugin
module.exports = {"Skill":"Skill_Skill__1mFZF","RemoveBtn":"Skill_RemoveBtn__2YF17"};